import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../../utils/formatPrice";
import { updateHomeGoal } from "../../services/homeGoal";
import { fetchAccountData } from "../../services/account";
import { useHomeGoalStore } from "../../stores/homeGoalStore";
import { useUserProfileStore } from "../../stores/profileStore";
import { convertToNumberAndMultiplyBy100 } from "../../utils/convertAmount";

const PLANSPEND_NUMBER = [
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"0",
	"<",
];

const BudgetSelectionView = () => {
	const { targetAmount, setTargetAmount } = useHomeGoalStore();
	const [buttonDisabled, setButtonDisabled] = useState(false);
	const { userProfile, setUserProfile } = useUserProfileStore();

	const navigate = useNavigate();

	useEffect(() => {
		if (userProfile?.homeGoal?.targetAmount) {
			setTargetAmount(userProfile.homeGoal.targetAmount.amount / 100);
		}
	}, [userProfile, setTargetAmount]);

	const handleClick = async () => {
		try {
			setButtonDisabled(true);
			await updateHomeGoal({
				targetAmount: {
					amount: convertToNumberAndMultiplyBy100(targetAmount.toString()),
					currency: "CAD",
				},
			});
			const accountData = await fetchAccountData();
			if (accountData) {
				setUserProfile(accountData);
			}
			navigate("/profile/savings");
		} catch (error) {
			console.error("Error updating home goal:", error);
		} finally {
			setButtonDisabled(false);
		}
	};

	const handlePrice = (item: string) => {
		if (item === "<") {
			const next = Math.floor(targetAmount / 10);
			setTargetAmount(next);
		} else {
			const candidate = targetAmount * 10 + Number(item);
			const next = candidate <= 9_999_999 ? candidate : targetAmount;
			setTargetAmount(next);
		}
	};

	return (
		<div className="h-full px-4 pt-2 text-black font-bold w-full space-y-16">
			<div className="font-bold text-2xl w-full">
				How much do you plan to
				<br /> spend on your home?
			</div>
			<div className="w-full space-y-6">
				<div className="space-y-8 flex flex-col items-center justify-center text-center w-full">
					<div className="text-5xl font-bold w-full">
						${formatPrice(targetAmount)}
					</div>
					<div className="grid grid-cols-3 text-2xl font-medium text-center mt-20 w-full">
						{PLANSPEND_NUMBER.map((item) => (
							<div
								key={item}
								onClick={() => handlePrice(item)}
								onKeyDown={(e) => {
									if (e.key === "Enter" || e.key === " ") handlePrice(item);
								}}
								className={`${item === "0" ? "col-start-2" : ""} py-6`}
							>
								{item}
							</div>
						))}
					</div>
				</div>
				<button
					type="button"
					onClick={() => {
						window
							._sendEvent("ZownCaAppSavingsSetGoal")
							.catch((error: unknown) => {
								console.error(error);
							})
							.finally(() => {
								handleClick();
							});
					}}
					disabled={buttonDisabled}
					className="bg-z-dark-moss-green disabled:bg-[#D9D9D9] text-white py-4 w-full px-4 rounded-full font-bold active:opacity-70"
				>
					Save
				</button>
			</div>
		</div>
	);
};

export { BudgetSelectionView };
